import { CollectionExpressionModel } from './CollectionExpressionModel';
import { ContentTemplateExpressionModel } from './ContentTemplateExpressionModel';
import { ExpressionModel } from './ExpressionModel';
import { ExpressionTypes } from './ExpressionTypes';
import { StringTemplateExpressionModel } from './StringTemplateModel';
import { VarExpressionModel } from './VarExpressionModel';

function getCollectionItemLabel(item: ExpressionModel | undefined): string {
	if (!item) return '';

	if (item.Type === ExpressionTypes.Const) {
		return String(item.Value);
	}

	if (item.Type === ExpressionTypes.Var) {
		const varExpression = item as VarExpressionModel;
		return Array.isArray(varExpression.Value) ? varExpression.Value.join('.') : item.Type;
	}

	if (item.Type === ExpressionTypes.StringTemplate) {
		return (item as StringTemplateExpressionModel).Content?.trim().substring(0, 40) || item.Type;
	}

	if (item.Type === ExpressionTypes.ContentTemplate) {
		return (item as ContentTemplateExpressionModel).TemplateId || 'Content Template';
	}

	if (item.Type === ExpressionTypes.Collection) {
		return '[...]';
	}

	return item.Type;
}

export function getCollectionExpressionLabel(expression: ExpressionModel): string {
	const items = ((expression as CollectionExpressionModel).Items ?? []).map(getCollectionItemLabel);
	const visibleItems = items.slice(0, 3);
	const suffix = items.length > visibleItems.length ? ', ..' : '';
	return `[ ${visibleItems.join(', ')}${suffix} ]`;
}
